import { defineComponent as $, getCurrentInstance as V, computed as r, ref as m, onMounted as L, onBeforeUnmount as N, openBlock as i, createElementBlock as u, Fragment as g, createVNode as B, unref as D, withCtx as I, createElementVNode as y, normalizeStyle as h, renderList as R, renderSlot as A, createCommentVNode as E } from "vue";
import { S } from "./scrollbar2-f7c66394.js";
import { _ as Y } from "./_plugin-vue_export-helper-dad06003.js";
const M = $({
  name: "rVirtualList",
  components: { Scrollbar2: S },
  props: {
    /**
     * 列表数据
     */
    data: {
      type: Array,
      default: () => []
    },
    /**
     * 每项高度
     */
    itemHeight: {
      type: [Number, String],
      default: 0
    },
    /**
     * 可视区域高度，当虚拟列表组件或所在父组件初始高度不确定，比如：diaplay为none，导致无法准确获取容器高度，可以直接用此属性设置可视区域高度
     */
    wrapperHeight: {
      type: [Number, String],
      default: 0
    },
    /**
     * 虚拟列表将依据此属性指定data中某个字段作为key，同列表key，用来帮助vue在diff中的原地复用，默认采用索引，例如：当列表中有较大的图片时
     */
    keyStr: {
      type: String,
      default: ""
    },
    /**
     * 虚拟列表class，用来设置虚拟列表最大可视区域的高度，最大高度默认为max-height:274px
     */
    wrapperClass: {
      type: [String, Array],
      default: ""
    }
  }
}), j = /* @__PURE__ */ Object.assign(M, {
  setup(F, { expose: _ }) {
    const { proxy: e } = V(), w = r(() => {
      const t = ["r-virtual-list"];
      return Array.isArray(e.wrapperClass) ? [...t, ...e.wrapperClass] : (t.push(e.wrapperClass), t.join(" "));
    }), s = m(0), k = r(() => o.value * e.itemHeight), x = r(() => Math.ceil(T.value / e.itemHeight) + 1), H = r(() => e.data.slice(o.value, b.value)), C = r(() => e.data.length * e.itemHeight), p = m(0), n = r(() => {
      var t, a;
      return (a = (t = p.value) == null ? void 0 : t.$refs) == null ? void 0 : a.wrap;
    }), T = r(() => {
      var t;
      return e.wrapperHeight || ((t = n.value) == null ? void 0 : t.clientHeight) || 0;
    }), o = r(() => Math.floor(s.value / e.itemHeight)), b = r(() => o.value + x.value), c = function() {
      var t;
      s.value = ((t = n.value) == null ? void 0 : t.scrollTop) || 0;
    };
    L(() => {
      var t;
      (t = n.value) == null || t.addEventListener("scroll", c), v();
    }), N(() => {
      var t;
      (t = n.value) == null || t.removeEventListener("scroll", c);
    });
    const v = function() {
      s.value = 0;
    }, l = function(t) {
      n.value.scrollTop = t;
    };
    return _({ initState: v, scrollTo: l, backToTop: function() {
      l(0);
    }, scrollToIndex: function(t) {
      const a = t * e.itemHeight;
      l(a);
    } }), (t, a) => (i(), u(
      g,
      null,
      [
        B(D(S), {
          "wrap-class": w.value,
          ref_key: "listRef",
          ref: p,
          native: !0
        }, {
          default: I(() => [
            y(
              "div",
              {
                class: "r-virtual-list-wrapper",
                style: h({
                  height: `${C.value}px`
                })
              },
              [
                y(
                  "div",
                  {
                    class: "r-virtual-list-options",
                    style: h({
                      transform: `translateY(${k.value}px)`
                    })
                  },
                  [
                    (i(!0), u(
                      g,
                      null,
                      R(H.value, (f, d) => (i(), u("div", {
                        class: "r-virtual-list-option",
                        ref_for: !0,
                        ref: `optionRef${d}`,
                        key: t.keyStr && f[t.keyStr] || d
                      }, [
                        A(t.$slots, "option", { optionData: f })
                      ]))),
                      128
                      /* KEYED_FRAGMENT */
                    ))
                  ],
                  4
                  /* STYLE */
                )
              ],
              4
              /* STYLE */
            )
          ]),
          _: 3
          /* FORWARDED */
        }, 8, ["wrap-class"]),
        E(` <div class="r-virtual-list" ref="listRef">
    <div
      class="r-virtual-list-wrapper"
      :style="{
        height: \`\${wrapperHeight}px\`
      }"
    >
      <div
        class="r-virtual-list-options"
        :style="{
          transform: \`translateY(\${transformY}px)\`
        }"
      >
        <div
          class="r-virtual-list-option"
          :ref="\`optionRef\${index}\`"
          v-for="(item, index) in optionsData"
          :key="(keyStr && item[keyStr]) || index"
        >
          <slot name="option" :optionData="item"></slot>
        </div>
      </div>
    </div>
  </div> `)
      ],
      2112
      /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */
    ));
  }
}), G = /* @__PURE__ */ Y(j, [["__file", "/Users/dave/Documents/dev/bmui3/src/packages/virtual-list/virtual-list.vue"]]);
export {
  G as V
};
